export default __webpack_public_path__ + "static/media/selecionador-de-cores.340f40e1.png";